const compactCurrencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const signedCurrencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  signDisplay: "exceptZero",
});

const percentFormatter = new Intl.NumberFormat("en-US", {
  style: "percent",
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
  signDisplay: "exceptZero",
});

export function formatPrice(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "—";
  return currencyFormatter.format(value);
}

/** Whole-dollar format for compact displays, e.g. "$1,299" */
export function formatPriceCompact(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "—";
  return compactCurrencyFormatter.format(value);
}

export function formatPriceChange(delta: number | null | undefined): string {
  if (delta == null || !Number.isFinite(delta)) return "—";
  return signedCurrencyFormatter.format(delta);
}

/**
 * @param percent - Percentage as a whole number, e.g. 3.8 for 3.8%.
 * Intl.NumberFormat percent style expects a fraction, so we divide by 100.
 */
export function formatPercentChange(
  percent: number | null | undefined,
): string {
  if (percent == null || !Number.isFinite(percent)) return "—";
  return percentFormatter.format(percent / 100);
}

export type ChangeType =
  | "price_increase"
  | "price_decrease"
  | "initial_observation"
  | "back_in_stock"
  | "out_of_stock"
  | "promo_start"
  | "promo_end"
  | "no_change";

const CHANGE_COLORS: Record<ChangeType, string> = {
  price_increase: "red",
  price_decrease: "green",
  initial_observation: "blue",
  back_in_stock: "blue",
  out_of_stock: "orange",
  promo_start: "yellow",
  promo_end: "yellow",
  no_change: "gray",
};

export function getChangeColor(changeType: ChangeType): string {
  return CHANGE_COLORS[changeType];
}

export function getDeltaColor(delta: number): string {
  if (delta > 0) return "red";
  if (delta < 0) return "green";
  return "gray";
}

export function formatPriceRange(min: number | null | undefined, max: number | null | undefined): string {
  if (min == null || max == null) return "—";
  if (min === max) return formatPriceCompact(min);
  return `${formatPriceCompact(min)} – ${formatPriceCompact(max)}`;
}
